import moment from 'moment';

export const getDayNumber = (day) => {
  const dayMap = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
  };
  return dayMap[day];
};

export const showSuccessMessage = () => {
  const successToast = document.createElement('div');
  successToast.className = 'success-toast';
  successToast.innerHTML = `
    <div class="success-content">
      <img src="icons/success.svg" alt="Success" class="success-icon" />
      <div class="success-text">
        <h3>Schedule Generated Successfully!</h3>
        <p>Your new schedule has been created and is ready to view.</p>
      </div>
    </div>
  `;
  document.body.appendChild(successToast);

  setTimeout(() => {
    successToast.classList.add('show');
  }, 100);

  setTimeout(() => {
    successToast.classList.remove('show');
    setTimeout(() => {
      document.body.removeChild(successToast);
    }, 300);
  }, 4000);
};

/**
 * Transform a sessionStorage config (ISO string hours) into the API payload shape.
 */
export const buildApiConfig = (config) => {
  const formattedHoursOfOperation = Object.entries(config.hoursOfOperation).reduce((acc, [day, hours]) => {
    const dayNumber = getDayNumber(day);
    if (dayNumber !== undefined && dayNumber !== null) {
      acc[dayNumber] = [
        moment(hours.start).format('HH:mm'),
        moment(hours.end).format('HH:mm')
      ];
    }
    return acc;
  }, {});

  const minLength = (config.minShiftLength.hours * 60) + config.minShiftLength.minutes;
  const maxLength = (config.maxShiftLength.hours * 60) + config.maxShiftLength.minutes;

  const fulfillLevelMap = {
    'always': 100,
    'best_effort': 50,
    'never': 0
  };

  return {
    unpublish: true,
    min_length: minLength,
    max_length: maxLength,
    hours_of_operation: formattedHoursOfOperation,
    start_date: moment(config.startDate).format('YYYY-MM-DD'),
    end_date: moment(config.endDate).format('YYYY-MM-DD'),
    min_schedule_hours_per_week: config.minScheduleHoursPerWeek,
    overtime_threshold: config.overtimeThreshold,
    minimum_break_minutes: config.minBreakTime,
    availability_fulfill_level: fulfillLevelMap[config.availabilityFulfillLevel] ?? 50,
    use_open_shifts: config.useOpenShifts ?? false
  };
};

/**
 * Build a display string from ISO-string hours of operation (as stored in sessionStorage).
 */
export const formatHoursOfOperationSummary = (hoursOfOperation) => {
  if (!hoursOfOperation) return 'Not configured';

  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  const summaries = days.map(day => {
    const hours = hoursOfOperation[day];
    if (!hours) return null;
    const dayAbbr = day.slice(0, 3).toUpperCase();
    return `${dayAbbr} ${moment(hours.start).format('h:mmA')}-${moment(hours.end).format('h:mmA')}`;
  }).filter(Boolean);

  if (summaries.length === 0) return 'Not configured';
  return summaries.join(', ');
};
